module.exports = {"thousand":"th.","million":"mil.","billion":"bil.","trillion":"tri.","":" ","undefined":" "}